import {Header} from "grommet";
import React from "react";

const AppBar = (props) => (

    <Header
        background="white"
        pad={{left: "medium", right: "small", vertical: "small"}}
        elevation="medium"
        sticky={"scrollup"}
        {...props}
    />
);

export default AppBar